module.exports = __webpack_public_path__ + "img/html-icon.07b7972b.svg";